exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".home[data-v-dcc77504]{padding:50px}.display-message[data-v-dcc77504],.home[data-v-dcc77504]{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}.display-message[data-v-dcc77504]{-ms-flex-direction:column;flex-direction:column;width:700px;height:500px;background:#fff;border-radius:20px}.display-message img[data-v-dcc77504]{height:100px;margin-bottom:100px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-dcc77504","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/home/Home.vue
// module id = 762
// module chunks = 0